(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/async-component/assets/javascripts/async-load.js') >= 0) return;  svs.modules.push('/components/app/async-component/assets/javascripts/async-load.js');
"use strict";


svs.app.asyncComponent.asyncLoad = (uri, getComponent) => {
  const acl = (_ref, callback) => {
    let {
      noCache
    } = _ref;
    return svs.core.module.load(uri, null, error => {
      const component = getComponent();
      if (!component) {
        return callback(new Error("Couldn't find component loaded from ".concat(uri)));
      }
      return callback(error, !error && component);
    }, null, false, noCache);
  };
  acl.displayName = 'asyncLoadComponent';
  return acl;
};

 })(window);